module.exports = __webpack_public_path__ + "img/fiat-2012-calendar-teaser-02.48077675.jpg";